import { useFormContext } from 'react-hook-form';
import { PaymentMethod } from '@features/events/common/payment-method';
import { Card } from '@shared/ui';
import { CustomEditorInputControlled } from '@src/modules/Authentication/InputsControlled';
import * as st from './styles.module.scss';

// const checkCost = (cost: null | string) => cost === null || (cost !== '0' && cost !== '');

export const Prepayment: React.FC = () => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();

  const errorMessage = (errors.prepayment_cost?.message as string) ?? '';

  const value = watch('cost_payment_method');

  // const clientCost = watch('client_cost');
  // const coachCost = watch('coach_cost');

  // const hasClientCost = checkCost(clientCost);
  // const hasCoachCost = checkCost(coachCost);

  // const isShowPrepayment = hasClientCost || hasCoachCost;

  // if (!isShowPrepayment) return <></>;

  return value !== 'O' ? (
    <fieldset>
      <div className={st.header}>
        <h3>Предоплата</h3>
        <p>{errorMessage}</p>
      </div>

      <Card className={st.cost}>
        <div className={st.wrapper}>
          <div className={st.cost__input}>
            <CustomEditorInputControlled
              control={control}
              name="prepayment_cost"
              label=""
              sufix={'RUB'}
            />
          </div>
          <PaymentMethod fieldName="prepayment_cost_method" disabled={true} />
        </div>
      </Card>
    </fieldset>
  ) : null;
};
